import React from "react";
import { useDashboard } from "./DashboardData";
import Icon from "components/Icon";
import "./index.scss";
import TATHistoryGraph from "./Components/TatGraph";
import { usePermissions } from "utils/roleUtils";
import HomeStrip from "../../components/HomeStrip";

const Dashboard = () => {
  const { stats, isLoading, handleCardClick } = useDashboard();
  const { isCanViewTatGraph } = usePermissions();

  return (
    <div className="dashboard-page">
      {/* Greeting alert — shows once per user, auto-closes after 10s */}
      <HomeStrip />

      <h1 className="page-title">Dashboard</h1>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="stat-card stat-card--clickable"
            style={{ borderTopColor: stat.color }}
            onClick={() => handleCardClick(stat)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleCardClick(stat)}
          >
            <div
              className="stat-icon"
              style={{ background: `${stat.color}20` }}
            >
              <Icon
                iconName={stat.iconName}
                alt={stat.iconName}
                width={28}
                height={28}
              />
            </div>
            <div className="stat-content">
              <h3 className={`stat-value ${isLoading ? "loading" : ""}`}>
                {stat.value}
              </h3>
              <p className="stat-title">{stat.title}</p>
            </div>
          </div>
        ))}
      </div>

      {/* TAT history graph  here */}

      {isCanViewTatGraph && (
        <div>
          <TATHistoryGraph />
        </div>
      )}
    </div>
  );
};

export default Dashboard;
